module.exports = __webpack_public_path__ + "static/img/fish29.ca1f6cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish29.png
// module id = B+bA
// module chunks = 0